import { BaSeParagraph, BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const ContainerImage = styled.div`
  margin: 20px 0 80px 0;
`;

export const Descricao = styled(BaSeParagraph)`
  font-size: 16px;
  color: ${BaSeTheme.colors.institucionais.cinzaSebrae30};
`;

export const ContainerImagem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0 0px 0;
`;

export const ContainerOptionsWithCheck = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
`;

export const ContentButton = styled.div`
  display: flex;
  gap: 15px;
`;
